import React from "react";
import { Reveal } from "@/components/blocks/Reveal";

export const PageHero = ({
  overline,
  title,
  subtitle,
  image,
  imageTestId = "page-hero-background-image",
}) => (
  <section className="relative overflow-hidden bg-navy pt-20" data-testid="page-hero">
    {image && (
      <div className="absolute inset-0">
        <img
          src={image}
          alt=""
          className="h-full w-full object-cover opacity-40"
          data-testid={imageTestId}
        />
        <div className="absolute inset-0 hero-overlay" />
      </div>
    )}
    <div className="relative mx-auto max-w-7xl px-5 py-24 md:py-32 lg:px-8">
      <Reveal>
        {overline && <span className="overline text-brand-orange">{overline}</span>}
        <h1 className="mt-5 max-w-4xl font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/70 md:text-lg">{subtitle}</p>
        )}
      </Reveal>
    </div>
  </section>
);

export default PageHero;
